import * as React from "react";
import Input from "../input_text/input_text";
import Dropdown from "../dropdown/dropdown";
import { TrashIcon } from "@heroicons/react/outline";

interface SpecItemProps {
  value: string;
  description: string;
  onValueChange: (value: string) => void;
  onDescriptionChange: (description: string) => void;
  onDelete: () => void;
  options: string[];
  placeholder: string;
}

const SpecItem: React.FC<SpecItemProps> = ({
  value,
  description,
  onValueChange,
  onDescriptionChange,
  onDelete,
  options,
  placeholder,
}) => (
  <div className="flex items-center space-x-4 mb-4">
    <div className="w-2/5 mb-4">
      <Dropdown
        value={value}
        onChange={onValueChange}
        options={options}
        placeholder={placeholder}
        variant="specs"
      />
    </div>
    <div className="w-3/5 mb-4">
      <Input
        value={description}
        onChange={onDescriptionChange}
        placeholder="Enter description"
        variant="specs"
      />
    </div>
    <button onClick={onDelete} className="text-red-500 hover:text-red-700">
      <TrashIcon className="w-6 h-6" />
    </button>
  </div>
);

export default SpecItem;
